import { FC, ReactNode, useContext } from 'react'
import styled from 'styled-components'
import { Outlet } from 'react-router-dom'
import { SidebarContext } from '../../shared/contexts/SidebarContext'
import { media } from '../../styles/newTheme/theme'
import Sidebar from './Sidebar'
import Header from './Header'

interface SidebarLayoutProps {
  children?: ReactNode
}

const LayoutWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100%;
`

const MainContent = styled.main<{ $sidebarWidth: string }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 0;
  overflow-x: hidden;
  transition: margin-left 0.3s ease;
  margin-left: ${({ $sidebarWidth }) => $sidebarWidth};

  ${media.down('l')} {
    margin-left: 0;
  }
`

const PageContent = styled.div`
  flex: 1;
  display: block;
  background: ${({ theme }) => theme.palette.background.default};
  min-height: calc(100vh - 64px);
  transition: background 0.2s;
`

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const { isCollapsed } = useContext(SidebarContext)

  const sidebarWidth = isCollapsed ? '72px' : '240px'

  return (
    <LayoutWrapper>
      <Sidebar />
      <MainContent $sidebarWidth={sidebarWidth}>
        <Header />
        <PageContent>
          <Outlet />
        </PageContent>
      </MainContent>
    </LayoutWrapper>
  )
}

export default SidebarLayout
